// extracted by mini-css-extract-plugin
module.exports = {"spam-content":"report_spam-content__RvH1w","header":"report_header__Uujmg","spam":"report_spam__9vNCA","is-reported":"report_is-reported__TFyNk"};